$(function () {

	hookUpCloseButton('');

	$('header .alert:not(.unhideable)').on("click", function () {
		closeAlert(this);
	});
	$('header .alert .cancel-button').on("click", function () {
		closeAlert($(this).closest('.alert')[0]);
	});
});

$(document).on("mvvm:updated", function () {
	hookUpCloseButton("#update-panel");

});

/**
 * @global
 */
function hookUpCloseButton(containerSelector) {
	$(containerSelector + ' .popup-container .overlay, ' + containerSelector + '.popup-container .close-button').on("click", function () {
		closePopup(this);
	});
}
/**
 * @global
 */
function closeAlert(alert) {
	$(alert).fadeOut(300, "swing", function () {
		$(alert).hide();
		// $(alert).remove();
	});
}
/**
 * @global
 */
function openPopup(containerSelector, closeCallback) {
	const $popupContainer = $(containerSelector);
	$popupContainer.removeClass('closed').addClass('open');
	$popupContainer.attr("aria-hidden", "false");
	$popupContainer.data('close-callback', closeCallback);
	const focusable = $popupContainer.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').first();
	focusable.focus();
}
/**
 * @global
 */
function closePopup(elementOrContainerSelector) {
	let $popupContainer = null;
	if (typeof (elementOrContainerSelector) === "string") {
		$popupContainer = $(elementOrContainerSelector);
	} else {
		$popupContainer = $(elementOrContainerSelector).parents('.popup-container').first();
	}
	$popupContainer.removeClass('open').addClass('closed');
	$popupContainer.attr("aria-hidden", "true");
	const callback = $popupContainer.data('close-callback');
	if (callback && typeof callback == "function")
		callback();
}
/**
 * @global
 */
function showErrorPopup(errorText) {
	$("#general-error-popup .content").html(errorText);
	openPopup("#general-error-popup");
}
/**
 * @global
 */
function showSuccessPopup(successText, closeAction) {
	$("#general-success-popup .content").html(successText);
	openPopup("#general-success-popup", closeAction);
}
/**
 * @global
 */
function showConfirmPopup(question, confirmAction, cancelAction, title) {
	const selector = "#general-confirm-popup";
	$(selector + " .content").html(question);
	if (title)
		$(selector + "# .header .title").html(title);

	const okAction = function (e) {
		closePopup(selector);
		if (typeof confirmAction == 'function') {
			confirmAction();
		}
	};
	$(selector + " .primary-action-button").on("click", okAction);

	const closeAction = function () {
		if (typeof cancelAction == "function")
			cancelAction();
		$(selector + " .primary-action-button").off("click", okAction);
	};

	openPopup(selector, closeAction);
}